<template>
  <v-container>
    <v-col>
      <h3>Контент страницы "О нас"</h3>

      <!--      <v-card>-->
      <v-card-text>
        <v-form ref="hpsAboutForm">
          <v-col cols="12">
            <ckeditor
              :editor="ckeditor"
              v-model="content"
              :config="ckConfig"
              type="classic"
              :upload-adapter="UploadAdapter"
            >
            </ckeditor>
            <input type="text" name="content" v-model="content" hidden />
          </v-col>
          <v-btn color="success" @click="save" :loading="loading">Соранить</v-btn>
        </v-form>
      </v-card-text>
      <!--      </v-card>-->
    </v-col>
  </v-container>
</template>

<script>
import ckeditorMixin from '@/mixins/ckeditor'
export default {
  name: 'CreateEditHPSAbout',
  mixins: [ckeditorMixin],
  data() {
    return {
      content: '',
      loading: false,
    }
  },
  mounted() {
    this.axios({
      url: '/v1/hps/about',
      method: 'get',
    })
      .then((res) => {
        this.content = res.data.content
      })
      .catch((err) => {
        this.showSnackbar(err.response ? err.response.data : err, 'error')
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    save() {
      const fd = new FormData(this.$refs.hpsAboutForm.$el)
      this.loading = true
      this.axios({
        url: '/v1/hps/about',
        method: 'post',
        data: fd,
      })
        .then((res) => {
          this.content = res.data.content
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
